import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HeaderKamsComponent } from './header-kams.component';
import { TextModule } from '../text/text.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TextModule,
    TranslateModule
  ],
  declarations: [HeaderKamsComponent],
  exports: [HeaderKamsComponent]
})
export class HeaderKamsComponentModule {}
